import { AccAuthBlock } from "./AccAuthBlock";
export default AccAuthBlock